import React from 'react';

import { tv } from '../../tv';

/**
 * What a person said, in a conversation: a filled shape with no border,
 * because a fill already says "this is a message" and a border on top of
 * it reads as a box inside a box. The fill is the accent's faintest step,
 * so the person's words carry the product's colour while the assistant's
 * words are the page itself. It shrinks to its content and never grows
 * past most of the column, the shape every conversation surface has
 * settled on. Alignment is the thread's decision, not the bubble's.
 */
const bubbleStyles = tv({
  base: [
    'ck:inline-block ck:max-w-full ck:rounded-5 ck:bg-accent-a-3 ck:px-4 ck:py-2',
    'ck:text-sm ck:text-text-default ck:whitespace-pre-wrap ck:break-words',
  ],
  variants: {
    /* A queued message, not yet sent, sits back until its turn. */
    isPending: { true: 'ck:opacity-50', false: '' },
  },
  defaultVariants: { isPending: false },
});

export interface BubbleProps {
  children: React.ReactNode;
  /** Queued behind a turn in progress; sent when that turn ends. */
  isPending?: boolean;
  id?: string;
}

export const Bubble = React.forwardRef<HTMLDivElement, BubbleProps>(function Bubble(
  { children, isPending = false, ...props },
  ref,
) {
  return (
    <div {...props} ref={ref} className={bubbleStyles({ isPending })} data-component="bubble">
      {children}
    </div>
  );
});
